import { render, staticRenderFns } from "./View-form.vue?vue&type=template&id=476e84bd&scoped=true&"
import script from "./View-form.vue?vue&type=script&lang=js&"
export * from "./View-form.vue?vue&type=script&lang=js&"
import style0 from "./View-form.vue?vue&type=style&index=0&id=476e84bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e84bd",
  null
  
)

export default component.exports